import rewardImg from "../assets/Rectangle-2.png"; // Replace with your actual reward image
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function RewardsSection() {
  return (
    <section className=" reward-bg-purple ">
      <div className="container col-lg-10 ">
        <div className="row align-items-center">
          {/* Left text content */}
          <div className="col-lg-6 py-6 text-center text-lg-start mb-4 mb-lg-0">
            {/* Optional faded background heading */}
            <h2 className="fw-bold fs-3 text-purple display-6 mb-3">
              Your Impact Deserves a Reward!
            </h2>
            <p className="fs-6 col-lg-8 ">
              Your Impact Deserves a Reward! Every approved report earns you
              reward points
            </p>

            <div className="d-flex flex-column gap-3 col-lg-6 col-10  mx-auto mx-lg-0 mt-4 justify-content-center justify-content-lg-start">
              <button className="btn btn-light rounded-pill px-4 py-2 fw-semibold">
                Redeem as discount coupons
              </button>
              <button className="btn btn-light rounded-pill px-4 py-2 fw-semibold">
                Withdraw to your bank account
              </button>
            </div>

            <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start">
              <a href="https://play.google.com/">
                <img src={googleImg} alt="Google Play" height="40" />
              </a>
              <a href="https://play.google.com/">
                <img src={appStoreImg} alt="App Store" height="40" />
              </a>
            </div>
          </div>

          {/* Right image */}
          <div className="col-lg-6 text-center">
            <img
              src={rewardImg}
              alt="Reward preview"
              className="img-fluid"
              style={{ maxHeight: "400px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default RewardsSection;
